import { Button, Card, Label, Select } from "flowbite-react";
import { ITemplate, Templates } from "../types/templates";
import { HeaderNoteList } from "../components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { headerSchema } from "../schemas/header.schema";
import { useEffect, useState } from "react";
import useHeaders from "../hooks/useHeaders";
import { useNavigate, useParams } from "react-router-dom";
import { toast, TypeOptions } from "react-toastify";
import { routes } from "../routes";

const defaultTemplate = Templates[0];

const HeaderDetailScreen = () => {
  const { id } = useParams();
  const [headerData, setHeaderData] = useState<any>([]);
  //const [notesLimit, setNotesLimit] = useState<number>(0);
  const [template, setTemplate] = useState<ITemplate>(defaultTemplate);
  const { header, findHeader, saveHeader, loading } = useHeaders();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(headerSchema),
  });

  const navigate = useNavigate();

  watch("templateId");

  const initialize = async (id: number) => {
    await findHeader(id);
  };

  const showToast = (message: string, type: TypeOptions = "warning") =>
    toast(message, {
      type: type,
    });

  const save = async (data: any) => {
    if (!data || !headerData) return;

    // DC: headerData should not have any null values
    // and should have the same length as template.notes
    const notesLimit = template?.notes ?? 0; //getNotesLimit();

    if (!notesLimit || notesLimit <= 0) {
      showToast("No se ha seleccionado ninguna plantilla.");
      return;
    }

    const isValidData =
      headerData.every((item: any) => item !== null && item !== undefined) &&
      headerData.length === notesLimit;
    if (!isValidData) {
      showToast("Complete todos y cada uno de los elementos de la cabecera");
      return;
    }

    // convert publishedUntil to timestamp
    const newHeaderData = headerData.map((item: any) => {
      return {
        ...item,
        published_until: item.published_until > 0 ? item.published_until : null,
      };
    });

    const info = {
      id: id ? parseInt(id) : undefined,
      headerData: newHeaderData,
      templateId: data.templateId,
    };

    const saved = await saveHeader(info);
    showToast(
      saved
        ? "Cabecera guardada correctamente."
        : "Ocurrió un error al guardar la cabecera.",
      saved ? "success" : "error"
    );

    if (saved && isNaN(parseInt(id!))) {
      navigate(`${routes.DASHBOARD}/${routes.HEADERS}`, {
        replace: true,
      });
    }
  };

  const getTemplate = () => {
    const templateValue = getValues("templateId");
    if (!templateValue) return defaultTemplate;
    const templateId = parseInt(templateValue.toString());
    if (templateId <= 0) return defaultTemplate;
    const template = Templates.find((item) => item.id === templateId);
    if (!template) return defaultTemplate;
    return template;
  };

  /*const getNotesLimit = () => {
        const templateId = getValues("templateId")
        if(!templateId) return 0
        const forceParsed = parseInt(templateId.toString())
        if(forceParsed <= 0) return 0
        const template = Templates.find(item => item.id === forceParsed)
        if(!template) return 0
        return template.notes
    }*/

  const setValues = () => {
    if (!header) return;
    setValue("templateId", header.template_id);
    setHeaderData(header.settings);
  };

  useEffect(() => {
    setValues();
    // eslint-disable-next-line
  }, [header]);

  useEffect(() => {
    (async () => {
      if (!id) return;

      const itemId = parseInt(id);
      if (!isNaN(itemId)) {
        await initialize(itemId);
      }
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!getValues("templateId")) return;
    setTimeout(() => {
      setHeaderData([]);
      setTemplate(getTemplate());
      //setNotesLimit(getNotesLimit())
    }, 100);
    // eslint-disable-next-line
  }, [getValues("templateId")]);

  return (
    <div className="m-4">
      <div className="mb-4">
        <div className="flex flex-row justify-between">
          <h1>Detalles de la cabcera</h1>
          <Button
            isProcessing={loading}
            disabled={loading}
            onClick={handleSubmit(save)}
          >
            Guardar cabecera
          </Button>
        </div>
      </div>
      <Card>
        <div className="flex flex-col mb-2">
          <Label className="mb-2">Template</Label>
          <Select
            {...register("templateId")}
            helperText={
              errors && errors.templateId ? errors.templateId.message : ""
            }
            required
            color={errors && errors.templateId ? "failure" : "gray"}
          >
            <option value="-1">- Elija una opción -</option>
            {Templates.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </Select>
        </div>
        <div className="flex flex-col mb-2">
          <HeaderNoteList
            template={template}
            settings={header?.settings}
            onChange={(d) => setHeaderData(d)}
          />
        </div>
      </Card>
    </div>
  );
};

export default HeaderDetailScreen;
